import { Outlet } from 'react-router-dom';
import { useShellAside } from '../../layout/ShellAside';
import ProfileAside from './ProfileAside';
import './ProfileLayout.scss';

/**
 * Layout route for `/profile/*`. It exists only to hang the section aside on
 * the shell for as long as any Profile page is mounted — the aside tracks the
 * current route through its own NavLinks, so it is published once.
 *
 * Same arrangement as AffiliateLayout, which is also why `/profile/*` runs on
 * the icon rail: the aside stands in for the expanded sidebar.
 */
export default function ProfileLayout() {
  useShellAside(() => <ProfileAside />, []);
  return <Outlet />;
}
